<template>
  <div class="myCertification">
    <pcHeader></pcHeader>

    <div class="heading_box">
      <div class="heading_sub">
        <div class="heading">
          <!-- <div class="title">签约权益</div> -->
          <div class="title">{{ $t('message.news.pleaseType') }}</div>

          <div class="text">
            <!-- 如果你有一颗热爱影像的心，签约认证摄影师，可以投稿,获得xxxxx，此处是权益说明文字 -->
          </div>
        </div>

        <div class="context_box">
          <div class="context">
            <div class="context_item" style="margin-right: 108px">
              <div class="img_box">
                <img src="../../../../../static/image/jr-icon-follow.png" alt="" />
              </div>
              <div style="color: #263245; font-size: 20px; margin-bottom: 6px; font-weight: 700">
                {{ $t('message.news.personalCertification') }}
              </div>
              <!-- <div style="color: #999999; font-size: 12px; line-height: 17px">
                仅限个人用户开通影像投稿功能
              </div>
              <div style="color: #999999; font-size: 12px">需提供身份证信息进行实名</div> -->
              <div style="color: #999999; font-size: 12px; line-height: 17px">
                {{ $t('message.news.realnameTip') }}
              </div>
              <div style="color: #999999; font-size: 12px">
                {{ $t('message.news.provideAuthentication') }}
              </div>
              <div v-if="state == 1" class="completed" @click="clickTo(1)">
                {{ $t('message.news.applyNow') }}
              </div>
              <div class="no_completed" v-else-if="state == 2">
                {{ $t('message.news.reviewPending') }}
              </div>
              <div v-else-if="state == 3" class="completed">{{ $t('message.news.Signed') }}</div>
              <div
                v-else-if="state == 4 && certificationType == 1"
                class="completed"
                @click="clickTo(1)"
              >
                {{ $t('message.news.applyAgain') }}
              </div>
              <div
                class="completed"
                v-else-if="state == 4 && certificationType != 1"
                @click="clickTo(1)"
              >
                {{ $t('message.news.applyNow') }}
              </div>

              <div class="failure" v-if="state == 4">
                <van-icon name="warning" color="#FF8F8F" size="17" />
                {{ $t('message.news.personalSigningInformation') }}
              </div>
            </div>
            <div class="context_item">
              <div class="img_box">
                <img src="../../../../../static/image/jr-icon-uildingsl.png" alt="" />
              </div>
              <div style="color: #263245; font-size: 20px; margin-bottom: 6px; font-weight: 700">
                {{ $t('message.news.enterpriseCertification') }}
              </div>
              <!-- <div style="color: #999999; font-size: 12px; line-height: 17px">
                企业/组织/机构用户开通影像投稿功能
              </div> -->
              <div style="color: #999999; font-size: 12px; line-height: 17px">
                <div>{{ $t('message.news.enterpriseFunction') }}</div>
              </div>
              <div style="color: #999999; font-size: 12px">
                {{ $t('message.news.provideOrganization') }}
              </div>
              <div class="completed" @click="clickTo(2)" v-if="state == 1">
                {{ $t('message.news.applyNow') }}
              </div>
              <div class="no_completed" v-else-if="state == 2">
                {{ $t('message.news.reviewPending') }}
              </div>
              <div class="no_completed" v-else-if="state == 3">
                {{ $t('message.news.reviewPassed') }}
              </div>
              <div
                class="completed"
                v-else-if="state == 4 && certificationType == 2"
                @click="clickTo(2)"
              >
                {{ $t('message.news.applyAgain') }}
              </div>
              <div
                class="completed"
                v-else-if="state == 4 && certificationType != 2"
                @click="clickTo(1)"
              >
                {{ $t('message.news.applyNow') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/cookie'
import pcHeader from '../../../../components/pcHeader.vue'
import { selectIsAuthentication } from '@/api/journalism.js'
import { selectCertificationInfo } from '@/api/journalism.js'
import { Toast } from 'vant'
export default {
  components: { pcHeader },
  data() {
    return {
      state: '0',
      certificationType: '1'
    }
  },
  computed: {},
  watch: {},
  methods: {
    async clickTo(index) {
      let query = {
        auditStatus: '',
        mobile: '',
        nickName: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        realName: '',
        userId: getCookie('userId')
      }
      const { data: res } = await selectCertificationInfo(query)
      if (res.resultCode == 200) {
        if (res.data.list[0]) {
          // 认证状态（1:已提交;2：不通过，3：通过）
          this.auditStatus = res.data.list[0].auditStatus
          if (res.data.list[0].auditStatus == 1) {
            return Toast('您的认证正在审核中')
          } else if (res.data.list[0].auditStatus == 2) {
            if (index == 1) {
              this.$router.push({
                path: '/user/personalCertificate',
                query: {
                  state: '2'
                }
              })
            } else if (index == 2) {
              this.$router.push({
                path: '/user/enterpriseCertification',
                query: {
                  state: '2'
                }
              })
            }
          } else if (res.data.list[0].auditStatus == 3) {
            return Toast('您的认证已通过，请勿重复点击认证')
          }
        } else {
          if (index == 1) {
            this.$router.push({
              path: '/user/personalCertificate'
            })
          } else if (index == 2) {
            this.$router.push({
              path: '/user/enterpriseCertification'
            })
          }
        }
      }
      // if (index == 1) {
      //   this.$router.push({
      //     path: '/user/personalCertificate'
      //   })
      // } else if (index == 2) {
      //   this.$router.push({
      //     path: '/user/enterpriseCertification'
      //   })
      // }
    },
    async search() {
      let userId = getCookie('userId')
      const { data: res } = await selectIsAuthentication({
        appId: userId
      })
      // console.log(res)
      if (res.resultCode == 200) {
        this.state = res.data
      }
    },
    async getSelectCertificationInfo() {
      let query = {
        auditStatus: '',
        mobile: '',
        nickName: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        realName: '',
        userId: getCookie('userId')
      }
      const { data: res } = await selectCertificationInfo(query)
      if (res.resultCode == 200) {
        if (res.data.list[0]) {
          this.certificationType = res.data.list[0].certificationType
        }
      }
    }
  },
  created() {
    this.search()
    this.getSelectCertificationInfo()
  },
  mounted() {}
}
</script>
<style scoped lang="less">
.myCertification {
  background-color: #f7f8fa;
  height: 100vh;
  .heading_box {
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;

    .heading_sub {
      width: 80%;
      height: 100vh;
      background-color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .heading {
      width: 80%;

      color: #1a1a1a;
      height: 194px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      .title {
        width: 728px;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .text {
        width: 728px;
        font-size: 14px;
      }
    }

    .context_box {
      width: 80%;
      background-color: #fff;
      .context {
        display: flex;
        justify-content: center;
        .context_item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 310px;
          height: 269px;
          padding: 0 10px;
          box-sizing: border-box;
          background-color: #f9f9f9;
          position: relative;
          .failure {
            position: absolute;
            top: -25px;
            left: 0;
            font-size: 12px;
          }
          .img_box {
            width: 44px;
            height: 44px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .no_completed {
            width: 80px;
            height: 32px;
            border-radius: 4px;
            color: #999999;
            font-size: 14px;
            background-color: #efefef;
            text-align: center;
            line-height: 32px;
            margin-top: 26px;
            cursor: pointer;
          }
          .completed {
            width: 80px;
            height: 32px;
            border-radius: 4px;
            color: #ffffff;
            font-size: 14px;
            background-color: #3562ff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            margin-top: 26px;
          }
        }
      }
    }
  }
}
</style>
